export default __webpack_public_path__ + "static/media/Trans_Black.93c9d70f.svg";